import styled from 'styled-components'

import Placeholder from '../Placeholder'

import Image from './Image'

const ImageContainer = styled.div`
  position: relative;
  overflow: hidden;

  ${Placeholder} {
    width: 100%;
    height: 100%;
  }

  ${Image} {
    z-index: 1;
  }

  picture + ${Placeholder},
  img + ${Placeholder},
  ${Image} + ${Placeholder} {
    animation: none;
  }
`

export default ImageContainer
